export function removeLangPrefix(str: string) {
  return str.substring(0, 1) + str.substring(4);
}
